import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
Swiper.use([Navigation]);
export default function infoSlidersInit() {
    const infoSliders = document.querySelectorAll('[data-js="infoSlider"]');
    if (infoSliders.length < 1)
        return;
    infoSliders.forEach((slider) => {
        const infoSliderPrev = slider.querySelector('[data-js="infoSliderPrev"]');
        const infoSliderNext = slider.querySelector('[data-js="infoSliderNext"]');
        const infoSliderEl = slider.querySelector('[data-js="infoSliderSlider"]');
        const navigation = infoSliderPrev && infoSliderNext ? {
            nextEl: infoSliderNext,
            prevEl: infoSliderPrev,
        } : false;
        const swiperParams = {
            slidesPerView: 1.2,
            spaceBetween: 20,
            watchOverflow: true,
            navigation: navigation,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 80
                },
                1250: {
                    slidesPerView: 3
                }
            },
        };
        if (infoSliderEl) {
            const infoSliderEx = new Swiper(infoSliderEl, swiperParams);
        }
    });
}
